import { SelfServeBuilderPopupTypes } from 'Popups';

const SelfServeTooltipTourConstants = {
  PREVIEW_BUTTON_TOOLTIP: 'SELF_SERVE_TOOLTIP_TOUR_PREVIEW_BUTTON_TOOLTIP',
  PREVIEW_BUTTON_TOOLTIP_IDX: 2,
  ANSWER_FILLED_TOOLTIP: 'SELF_SERVE_TOOLTIP_TOUR_ANSWER_FILLED_TOOLTIP',
  ANSWER_FILLED_TOOLTIP_IDX: 1,
  ANSWER_QUESTION_TOOLTIP: 'SELF_SERVE_TOOLTIP_TOUR_ANSWER_QUESTION_TOOLTIP',
  ANSWER_QUESTION_TOOLTIP_IDX: 0,
  PREVIEW_BUTTON_TOOLTIP_SHOW: 'SELF_SERVE_TOOLTIP_TOUR_PREVIEW_BUTTON_TOOLTIP_SHOW',
  PREVIEW_MODAL_IS_MOUNTED: 'SELF_SERVE_TOOLTIP_TOUR_PREVIEW_MODAL_IS_MOUNTED',
  PREVIEW_TOOLTIP_HIDE_ALL: 'PREVIEW_TOOLTIP_HIDE_ALL',
  TOOLBOX_CHECKBOX_TOOLTIP: 'TOOLBOX_CHECKBOX_TOOLTIP',
  TOOLBOX_MULT_CHOICE_TOOLTIP: 'TOOLBOX_MULT_CHOICE_TOOLTIP',
  TOOLBOX_SIGNATURE_TOOLTIP: 'TOOLBOX_SIGNATURE_TOOLTIP',
  TOOLBOX_TEXTBOX_TOOLTIP: 'TOOLBOX_TEXTBOX_TOOLTIP',
  TOOLBOX_TIPS_LIST_TOOLTIP: 'TOOLBOX_TIPS_LIST_TOOLTIP',
  TOOLBOX_TIPS_TOOLTIP: 'TOOLBOX_TIPS_TOOLTIP',
  TOOLBOX_TOOLTIP_HIDE_ALL: 'SELF_SERVE_TOOLTIP_TOUR_TOOLBOX_TOOLTIP_HIDE_ALL',
  TOOLBOX_TOOLTIP_HIDE_CURRENT: 'SELF_SERVE_TOOLTIP_TOUR_TOOLBOX_TOOLTIP_HIDE_CURRENT',
  TOOLBOX_TOOLTIP_LOCATION_SET: 'SELF_SERVE_TOOLTIP_TOUR_TOOLBOX_TOOLTIP_LOCATION_SET',
  TOOLBOX_TOOLTIP_SHOW: 'SELF_SERVE_TOOLTIP_TOUR_TOOLBOX_TOOLTIP_SHOW',
  TOOLBOX_TOUR_BEGIN: 'SELF_SERVE_TOOLTIP_TOUR_TOOLBOX_TOUR_BEGIN',
  TOOLTIP_NEXT: 'SELF_SERVE_TOOLTIP_TOUR_TOOLTIP_NEXT',
  TOOLTIP_TOUR_NOT_STARTED_IDX: -1,
};

export const TOOLBOX_TOOLTIPS = [
  SelfServeTooltipTourConstants.TOOLBOX_TEXTBOX_TOOLTIP,
  SelfServeTooltipTourConstants.TOOLBOX_MULT_CHOICE_TOOLTIP,
  SelfServeTooltipTourConstants.TOOLBOX_CHECKBOX_TOOLTIP,
  SelfServeTooltipTourConstants.TOOLBOX_SIGNATURE_TOOLTIP,
  SelfServeTooltipTourConstants.TOOLBOX_TIPS_LIST_TOOLTIP,
  SelfServeTooltipTourConstants.TOOLBOX_TIPS_TOOLTIP,
];

export const SELF_SERVE_POPUPS_TO_TOOLBOX_TOOLTIPS = {
  [SelfServeBuilderPopupTypes.TEXTBOX]: SelfServeTooltipTourConstants.TOOLBOX_TEXTBOX_TOOLTIP,
  [SelfServeBuilderPopupTypes.SIGNATURE]: SelfServeTooltipTourConstants.TOOLBOX_SIGNATURE_TOOLTIP,
  [SelfServeBuilderPopupTypes.CHECKBOX]: SelfServeTooltipTourConstants.TOOLBOX_CHECKBOX_TOOLTIP,
  [SelfServeBuilderPopupTypes.MULTIPLE_CHOICE]: SelfServeTooltipTourConstants.TOOLBOX_MULT_CHOICE_TOOLTIP,
};

export default SelfServeTooltipTourConstants;



// WEBPACK FOOTER //
// ./src-react/SelfServeTooltipTour/TooltipTourConstants.jsx